export default __webpack_public_path__ + "static/media/sentiment_dissatisfied.d8806fec.svg";